import { Check } from "lucide-react"
import "./UploadSuccess.css"

export default function UploadSuccess() {
  return (
    <div className="upload-success">
      <div className="success-circle">
        <Check className="success-icon" />
        <span className="success-text">Success</span>
      </div>
      <h2 className="success-title">Recording uploaded!</h2>
    </div>
  )
}

